var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2849 1.5H18.5515C19.903 1.5 20.9993 2.6059 20.9993 3.97018V7.2641C20.9993 8.62735 19.903 9.73429 18.5515 9.73429H15.2849C13.9323 9.73429 12.8359 8.62735 12.8359 7.2641V3.97018C12.8359 2.6059 13.9323 1.5 15.2849 1.5Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44892 1.5H6.71449C8.06703 1.5 9.16341 2.6059 9.16341 3.97018V7.2641C9.16341 8.62735 8.06703 9.73429 6.71449 9.73429H3.44892C2.09638 9.73429 1 8.62735 1 7.2641V3.97018C1 2.6059 2.09638 1.5 3.44892 1.5Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44892 13.2656H6.71449C8.06703 13.2656 9.16341 14.3715 9.16341 15.7368V19.0297C9.16341 20.394 8.06703 21.4999 6.71449 21.4999H3.44892C2.09638 21.4999 1 20.394 1 19.0297V15.7368C1 14.3715 2.09638 13.2656 3.44892 13.2656Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2849 13.2656H18.5515C19.903 13.2656 20.9993 14.3715 20.9993 15.7368V19.0297C20.9993 20.394 19.903 21.4999 18.5515 21.4999H15.2849C13.9323 21.4999 12.8359 20.394 12.8359 19.0297V15.7368C12.8359 14.3715 13.9323 13.2656 15.2849 13.2656Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.70fc83004ee6dc5bea4aa96f30555a48.svg";
export { ForwardRef as ReactComponent };